import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
  DialogTitle,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "../../Sass/Common.scss";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import { makeStyles } from "@mui/styles";
import { ReactComponent as UrgencyIcon } from "Assets/Icons/UrgencyIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as NoteTextIcon } from "Assets/Icons/PharmsmartIcon/NoteTextcon.svg";
import { ReactComponent as ModalCloseIcon } from "Assets/Icons/PharmsmartIcon/ModalCloseIcon.svg";
import useViewport from "Hooks/useViewport";
const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      display: "flex",
      justifyContent: "center",
      "&>div": {
        "&>h3": {
          //   marginTop: "30px !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
          fontSize: "18px !important",
        },
      },
      "&>iframe": {
        marginBottom: "20px !important",
      },
    },
  },
  dialogActionBtn: {
    // marginBottom: "20px",
    paddingTop: "20px !important",
  },
  reUrgencyIcon: {
    "&>div": {
      background: "rgba(90, 104, 114, 0.1)",
      border: "2px solid rgba(90, 104, 114, 0.7)",
      borderRadius: "68px",
      padding: "20px",
    },
    "&>svg": {
      color: "rgba(90, 104, 114, 0.1)",
    },
  },
  rsTitle: {
    "&>h3": {
      textAlign: "center",
      fontSize: "25px !important",
      fontWeight: "500  !important",
      color: "black",
      width: "100%",
    },
  },
  video: {
    width: "100%",
    height: "550px",

    [theme.breakpoints.down("1400")]: {
      height: "450px",
    },
  },
  rsDialogMainRoot: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      top: "65px",
      "@media (max-height: 740px)": {
        top: "0px",
      },
      "&>div": {
        padding: "10px 0px !important",
      },
    },
  },
}));

const VideoDialog = (props) => {
  const classes = useStyle();
  const { open, setOpen, title, videoPath, tourType, handleTourUpdate } = props;
  let { height, width } = useViewport();
  const handleClose = () => {
    if(tourType === "repeatOrder" && tourType !== ""){
      handleTourUpdate("order")
    }
    setOpen(false);
  };
  useEffect(() => {
    // setTimeout(() => {
    //   const video = document.getElementById("video");
    //   // if (video) {
    //   //   // video.play();
    //   // }
    // }, 500);
  }, [open]);
  return (
    <>
      <Dialog
        open={open}
        maxWidth="lg"
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        className={classes.rsDialogMainRoot}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
      >
        <PrimaryDialogTitle handleClose={handleClose} title={title} />
        <Box className={classes.resConfirmationBox}>
          <DialogContent>
            <iframe
              id="video"
              width="1085"
              height={height < 750 ? "500" : "600"}
              src={`${videoPath}?autoplay=1&mute=0&rel=0&vq=hd1080`} // Added vq=hd1080 for quality
              title="YouTube video"
              frameBorder="0"
              allowFullScreen
              allow="autoplay; fullscreen"
            ></iframe>
            {/* <video id="video" width="1085" height="600" controls>
              <source src={`${videoPath}`} type="video/mp4" />
            </video> */}
          </DialogContent>
        </Box>
        {/* <DialogActions className={classes.dialogActionBtn}>
          <Button variant="outlined" onClick={handleClose} className="BtnGray">
            Close
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
};

export default VideoDialog;
